import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Libraries
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment/moment";

export default function OrderFilter({ filterOrders }) {
    const navigate = useNavigate()
    

    const [form, setForm] = useState({
        customerId: "",
        supplierId: "",
        agentId: "",
        status: "",
        orderNo: "",
        valueGreaterThan: "",
        valueLessThan: "",
        dateGreaterThan: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        dateLessThan: "",
    });

    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [agents, setAgents] = useState([]);

    const { user } = useAuthContext();
    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    function submitClicked() {
        filterOrders(form);
    }

    // On Load
    useEffect(() => {

        // Load customers
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/customers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setCustomers(res.data);
                }
            });

        // Load suppliers
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setSuppliers(res.data);
                }
            })

        // Load Agents
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/users/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    console.log("response:", res.data);
                    setAgents(res.data);
                }
            })


        setField("dateGreaterThan", moment().subtract(1, 'months').format('YYYY-MM-DD'));
    }, [])


    return (
        <div className="filterBox">
            <div className="row">
                <div className="col-12">
                <h5>Filter Options</h5>
                </div>
            </div>
            

            <div className="row">
                { /* Status */}
                <div className="form-group col-2">
                    <label>Status</label>
                    <div className="select">
                        <Form.Select
                            onChange={(e) => setField("status", e.target.value)}
                            value={form && form.status}
                        >
                            <option value="">All Status</option>
                            <option value="InProgress">In Progress</option>
                            <option value="Submitted">Submitted</option>

                        </Form.Select>
                    </div>
                </div>

                { /* Customer */}
                <div className="form-group col-2">
                    <label>Customer</label>
                    <div className="select">
                        <Form.Select
                            onChange={(e) => setField("customerId", e.target.value)}
                            value={form && form.customerId}
                        >
                            <option value="">All Customers</option>
                            {customers && (customers.map((customer) => {
                                return <option key={customer.id} value={customer.id}>{customer.name} {customer.farm && `(${customer.farm})`}</option>
                            }))}
                        </Form.Select>
                    </div>
                </div>

                { /* Supplier */}
                <div className="form-group col-3">
                    <label>Supplier</label>
                    <div className="select">
                        <Form.Select
                            onChange={(e) => setField("supplierId", e.target.value)}
                            value={form && form.supplierId}
                        >
                            <option value="">All Suppliers</option>
                            {suppliers && (suppliers.map((supplier) => {
                                return <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                            }))}
                        </Form.Select>
                    </div>
                </div>

                { /* Agents */}
                <div className="form-group col-3">
                    <label>Agents</label>
                    <div className="select">
                        <Form.Select
                            onChange={(e) => setField("agentId", e.target.value)}
                            value={form && form.agentId}
                        >
                            <option value="">All Agents</option>
                            {agents && (agents.map((agent) => {
                                return <option key={agent.id} value={agent.id}>{agent.name}</option>
                            }))}
                        </Form.Select>
                    </div>
                </div>

                

                { /* Order No */}
                <div className="form-group col-2">
                    <label>Order No</label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="e.g AFS240001"
                        onChange={(e) => setField("orderNo", e.target.value)}

                    />
                </div>
            
                
            </div>

            <div className="row">
                { /* Value - Greater Than */}
                <div className="form-group col-2">
                    <label>Value</label>
                    <InputGroup>
                        <InputGroup.Text>Over</InputGroup.Text>
                    
                        <Form.Control
                            required
                            type="text"
                            placeholder="e.g 500"
                            onChange={(e) => setField("valueGreaterThan", e.target.value)}

                            />
                        </InputGroup>
                </div>

                { /* Value - Less Than */}
                <div className="form-group col-2">
                    <label>Value</label>
                    <InputGroup>
                        <InputGroup.Text>Below</InputGroup.Text>

                        <Form.Control
                            required
                            type="text"
                            placeholder="e.g 500"
                            onChange={(e) => setField("valueLessThan", e.target.value)}

                        />
                    </InputGroup>
                </div>

                { /* Date - Greater Than */}
                <div className="form-group col-3">
                    <label>Date</label>
                    <InputGroup>
                        <InputGroup.Text>After</InputGroup.Text>

                        <Form.Control
                            required
                            type="date"
                            placeholder="e.g 25/12/2024"
                            onChange={(e) => setField("dateGreaterThan", e.target.value)}
                            value={form && form.dateGreaterThan}
                        />
                    </InputGroup>
                </div>

                { /* Date - Less Than */}
                <div className="form-group col-3">
                    <label>Date</label>
                    <InputGroup>
                        <InputGroup.Text>Before</InputGroup.Text>

                        <Form.Control
                            required
                            type="date"
                            placeholder="e.g 25/12/2025"
                            onChange={(e) => setField("dateLessThan", e.target.value)}
                            
                        />
                    </InputGroup>
                </div>
                <div className="col-2">
                    <br />
                    <button className="btn btn-primary"  onClick={submitClicked}>Filter</button>
                </div>

            </div>
        </div>
    )
}
